export class ParamModel {
    params: any = {};
}